import React, { useState, useEffect, useMemo } from "react";
import "./HeroSection.css";

/* ICONS */
import voice from "../../../Assets/Icons/1.png";
import gallery from "../../../Assets/Icons/2.png";
import man from "../../../Assets/Icons/3.png";
import automation from "../../../Assets/Icons/4.png";

import HeroBG from "../../../Assets/Home/HeroSection/Hero.jpg";
import PlayCircle from "../../../Assets/Icons/play_circle.ico";
import cart from "../../../Assets/Icons/ai-star.png";

import Img1 from "../../../Assets/Home/HeroSection/slide1.png";
import Img2 from "../../../Assets/Home/HeroSection/slide2.png";
import Img3 from "../../../Assets/Home/HeroSection/slide3.png";
import Img4 from "../../../Assets/Home/HeroSection/slide4.png";

function HeroSection({ onOpenStoreKeeper, onOpenConsumers }) {
  // Memoize images array to prevent unnecessary re-renders
  const images = useMemo(() => [Img1, Img2, Img3, Img4], []);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    // 1. Preload Images to Browser Cache
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    // 2. Slider Interval
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [images]);

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const headerOffset = 80;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${HeroBG})` }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content-wrapper">
        <div className="hero-main-row">

          {/* LEFT SIDE */}
          <div className="hero-left">
            <span className="hero-tag">
              <img src={cart} alt="cart" className="tag-icon" />
              Revolutionary AI Store Management
            </span>

            <h1 className="hero-title">
              FULUPO <span style={{ fontWeight: 500 }}>|</span> <br />
              <span className="hero-title-yellow">AI STORE KEEPER</span>
            </h1>

            <p className="hero-desc">
              Complete AI-powered store management SaaS platform for modern retailers. Transform your business with Voice AI, Image recognition, intelligent analytics and automation for the future of deep tech retail connecting the retailers, consumers, vendors and delivery partners.
            </p>

            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => handleScroll("products")}>
                Explore Products
              </button>
              <button className="btn-outline" onClick={() => handleScroll("demo")}>
                <img src={PlayCircle} alt="play" className="play-icon" />
                Watch Demo
              </button>
            </div>

            <div className="hero-mobile-buttons">
              <button className="btn-glass" onClick={onOpenStoreKeeper}>Store Keeper</button>
              <button
                className="btn-glass"
                onClick={() => {
                  const screenWidth = window.innerWidth;
                  if (screenWidth >= 320 && screenWidth <= 768) {
                    window.open("https://play.google.com/store", "_blank");
                  } else {
                    onOpenConsumers();
                  }
                }}
              >
                Consumers
              </button>
            </div>
          </div>

          {/* RIGHT SIDE – FIXED SLIDER */}
          <div className="hero-right">
            <div className="hero-slider-container" style={{ position: 'relative', overflow: 'hidden' }}>
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Hero Visual ${index}`}
                  className={`hero-img hero-slide ${index === current ? "active" : ""}`}
                  style={{
                    position: index === 0 ? "relative" : "absolute", // Base image layout setup
                    top: 0,
                    left: 0,
                    opacity: index === current ? 1 : 0,
                    transition: "opacity 0.8s ease-in-out", // Smooth transition
                    visibility: index === current ? "visible" : "hidden"
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* FEATURES */}
        <div className="hero-features">
          <Feature icon={voice} title="Voice AI" desc="Natural language processing for seamless transactions" />
          <Feature icon={gallery} title="Image Recognition" desc="Computer vision for instant product identification" />
          <Feature icon={man} title="Smart Analytics" desc="AI-driven insights, suggestions and predictive analytics" />
          <Feature icon={automation} title="Automation" desc="Intelligent workflow and process automation" />
        </div>
      </div>
    </div>
  );
}

const Feature = ({ icon, title, desc }) => (
  <div className="feature-card">
    <div className="icon-box">
      <img src={icon} alt={title} className="icons" />
    </div>
    <div className="feature-text">
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  </div>
);

export default HeroSection;